import { UrlConstants } from "../url.constants";
export class ApiPropertyValuationValuationProperty {
    static URL = UrlConstants.API_V2 + "PropertyValuationProperty";
}
